import styled from 'styled-components';
import { ASSETS } from '../../../../../../assets';
import { THEME } from '../../../../../../themes';
import { Title3Font, Subtitle1Font } from '../../../../../../themes/fonts';

export const CompanyLabel = styled.div`
  ${Title3Font};
  color: ${THEME.COLORS.PRIMARY_DARK};
  font-weight: 600;
  display: inline-flex;
  white-space: pre-wrap;
  align-items: center;
  position: relative;
`;

export const SingleRoleCompanyLabel = styled.div<{
  isInsightsModalVisible: boolean,
  isCompanyInsightsButtonVisible: boolean,
}>`
  ${Subtitle1Font};
  color: ${THEME.COLORS.PRIMARY_DARK};
  padding: 7.5px;
  background-color: ${({ isInsightsModalVisible }) => isInsightsModalVisible ?
    `rgba(236,9,130,${THEME.OPACITY.DIVIDER})` :
    THEME.COLORS.PURE_WHITE};
  width: fit-content;
  border-radius: ${THEME.RADIUS.BASE};
  margin-top: ${THEME.SPACING.MICRO};
  margin-left: -${THEME.SPACING.TINY};
  margin-bottom: -8px;
  position: relative;
  cursor: ${({ isCompanyInsightsButtonVisible }) => isCompanyInsightsButtonVisible ?
    'pointer' : 'unset'};
  strong {
    font-weight: 600;
  }

  :after {
    content: "";
    display:inline-block;
    height:16px;
    width:16px;
    background-size: 16px 16px;
    background-repeat: no-repeat;
    margin-left: ${THEME.SPACING.TINY};
    background-image: ${({ isCompanyInsightsButtonVisible }) => isCompanyInsightsButtonVisible ?
    `url(${ASSETS.INSIGHTS_PANEL})` : 'unset'};
    vertical-align: middle;
  }
`;

export const MultiRoleCompanyLabel = styled.div<{
  isInsightsModalVisible: boolean,
  isCompanyInsightsButtonVisible: boolean,
}>`
  background-color: ${({ isInsightsModalVisible }) => isInsightsModalVisible ?
    `rgba(236,9,130,${THEME.OPACITY.DIVIDER})` :
    THEME.COLORS.PURE_WHITE};
  padding: 7.5px;
  margin-top: -8px;
  margin-bottom: -8px;
  margin-left: -${THEME.SPACING.TINY};
  border-radius: ${THEME.RADIUS.BASE};
  cursor: ${({ isCompanyInsightsButtonVisible }) => isCompanyInsightsButtonVisible ?
    'pointer' : 'unset'};

  :after {
    content: ${({ isCompanyInsightsButtonVisible }) => isCompanyInsightsButtonVisible ?
    `url(${ASSETS.INSIGHTS_PANEL})` : 'unset'};
    margin-left: ${THEME.SPACING.TINY};
    vertical-align: middle;
  }
`;

export const IconContainer = styled.div`
  margin-left: ${THEME.SPACING.MICRO};
  display: flex;
`;

export const ModalBackdrop = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
`;
